export const SECONDS_IN_HOUR = 60 * 60;
export const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
export const SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;
export const SECONDS_IN_TWO_WEEKS = SECONDS_IN_WEEK * 2;
export const SECONDS_IN_MONTH = SECONDS_IN_WEEK * 4;
export const SECONDS_IN_SIX_MONTHS = SECONDS_IN_MONTH * 6;
export const SECONDS_IN_YEAR = 365.25 * SECONDS_IN_DAY;
//# sourceMappingURL=time.js.map